<template>
	<Card>
		<div  class="yl-flex flex_between">
			<Form :label-width="80">
				<FormItem label="时间">
					<RadioGroup v-model="timePeriod" @on-change="changeDate">
						<Radio label="0" border><span>不限</span></Radio>
						<Radio label="1" border><span>今日</span></Radio>
						<Radio label="2" border><span>昨天</span></Radio>
						<Radio label="3" border><span>本周</span></Radio>
						<Radio label="4" border><span>上周</span></Radio>
						<Radio label="5" border><span>本月</span></Radio>
						<Radio label="6" border><span>上月</span></Radio>
						<Radio label="7" border><span>自定义</span></Radio>
						<DatePicker v-if="timePeriod == '7' " :value="timePeriodDate" @on-change="changeTimePeriod"
							type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
					</RadioGroup>
				</FormItem>
				<FormItem label="条件">
					<el-select v-model="city" style="width: 100px;margin-left: 10px;width: 150px;"  placeholder="请选择城市">
						<el-option v-for="item in cityList" :value="item.city" :key="item.city">
							{{ item.city}}
						</el-option>
					</el-select>
					<el-select v-model="src" style="width: 100px;margin-left: 10px;width: 150px;" :reserve-keyword="true" filterable multiple placeholder="请选择媒体代码">
						<el-option  v-for="item in srcList" :key="item.src" :label="item.src"
							:value="item.src">
						</el-option>
					</el-select>
					<el-select v-model="operationUser" style="width: 100px;margin-left: 10px;width: 150px;"
						:reserve-keyword="true" filterable multiple placeholder="请选择运营">
						<el-option v-for="item in operationList" :value="item.uid" :label="item.username"
							:key="item.uid">
							{{ item.username}}
						</el-option>
					</el-select>
					<el-Input placeholder="新版创意id" v-model="newSearchAdid" style="width: 100px;margin-left: 10px;width: 150px;"></el-Input>
					<el-Input placeholder="创意id" v-model="searchAdid" style="width: 100px;margin-left: 10px;width: 150px;"></el-Input>
					<el-Input placeholder="计划id" v-model="adgroup_id" style="width: 100px;margin-left: 10px;width: 150px;"></el-Input>
					<el-Button type="primary" @click="mySearch" style="margin-left: 10px;">搜索</el-Button>
					<el-Button @click="initSearch" style="margin-left: 10px;">重置</el-Button>
				</FormItem>
			</Form>
		</div>
		<div style="width: 100% ;margin-top: 20px;">
			<Table :columns="defaultColumns" :data="datas"  ref="table">
				<template slot-scope="{ row,index }" slot="dynamic_creative_id">
					<span style="color:#63B3E6;cursor: pointer;" @click.stop="newTidDataClick(row.dynamic_creative_id)">{{row.dynamic_creative_id}}</span>
				</template>
				<template slot-scope="{ row,index }" slot="tid">
					<span style="color:#63B3E6;cursor: pointer;" @click.stop="tidDataClick(row.tid)">{{row.tid}}</span>
				</template>
				<template slot-scope="{ row,index }" slot="adgroup_id">
					<span style="color:#63B3E6;cursor: pointer;" @click.stop="adidDataClick(row.adgroup_id)">{{row.adgroup_id}}</span>
				</template>
				<template slot-scope="{ row,index }" slot="twoplus">
					<div v-if="row.our_num !=0">
						<span>{{row.twoplus+row.three+row.four}}/{{(((row.twoplus+row.three+row.four)/row.our_num).toFixed(2))}}</span>
					</div>
					<div v-if="row.our_num ==0">
						<span>{{row.twoplus+row.three+row.four}}/0</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="zhuangku_rate">
					<div v-if="row.zhuangku_rate >0.2">
						<span style="color:#ffaa00;cursor: pointer;">{{row.zhuangku_rate}}</span>
					</div>
					<div v-else>
						<span>{{row.zhuangku_rate}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="threePlus">
					<div v-if="row.our_num !=0">
						<span>{{row.three+row.four}}/{{(((row.three+row.four)/row.our_num).toFixed(2))}}</span>
					</div>
					<div v-if="row.our_num ==0">
						<span>{{row.three+row.four}}/0</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="four">
					<div v-if="row.our_num !=0">
						<span>{{row.four}}/{{(((row.four)/row.our_num).toFixed(2))}}</span>
					</div>
					<div v-if="row.our_num ==0">
						<span>{{row.four}}/0</span>
					</div>
				</template>				
				<template slot-scope="{ row,index }" slot="threePlusReal">
					<div v-if="row.all_num !=0">
						<span>{{row.three+row.four}}/{{(((row.three+row.four)/row.all_num).toFixed(2))}}</span>
					</div>
					<div v-if="row.all_num ==0">
						<span>{{row.three+row.four}}/0</span>
					</div>
				</template>
			</Table>
		</div>
		<div>
			<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
				:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
		</div>
		<Modal v-model="adidDataModal" width="1200" title="">
			<wechatAdidData :adid="adid" :click_type="click_type" :timePeriod="timePeriod" :timePeriodDate="timePeriodDate"  :city="city" :src="src" ></wechatAdidData> 
		</Modal>
	</Card>
</template>
<script>
	import {
		mapGetters
	} from "vuex";
	import {
		getAdvCity,
	} from "../../api/runSet";
	import {
		getCidTypeList,
		getToutiaoAdvDataList,
		getWechatSrc,
		getAllOperationList,
		getWechatAdvDataList
	} from "../../api/advManage.js";
	import wechatAdidData from "./components/wechatAdidData.vue"
	import cityData from "../../assets/citydata";

	export default {
		name: "wechat_data",
		components: {
			wechatAdidData
		},

		data() {
			return {
				datas: [],
				timePeriod:'1',
				timePeriodDate:[],
				page: 1,
				pageSize: 20,
				editStatus: 0,
				pageSizeOpts: [10, 50, 100, 500],
				count: 0,
				city: '',
				src:'',
				advCity: '',
				cityList: [],
				cidTypeList: [],
				srcList:[],
				accountList:[],
				operationList:[],
				adidDataModal:false,
				adid:'',
				searchAdid:'',
				newSearchAdid:'',
				operationUser:'',
				adgroup_id:'',
				click_type:'tid',
				defaultColumns: [{
						"title": "新版创意id",
						"slot": "dynamic_creative_id",
						"align": 'center',
					},{
						"title": "创意id",
						"slot": "tid",
						"align": 'center',
					},{
						"title": "计划id",
						"slot": "adgroup_id",
						"align": 'center',
					},
					{
						"title": "媒体代码",
						"key": "src",
						"align": 'center',
					},
					{
						"title": "所有城市量",
						"key": "all_num",
						"align": 'center',
					},
					{
						"title": "已回传数量",
						"key": "our_num",
						"align": 'center',
					},
					{
						"title": "已分发数量",
						"key": "distribute_num",
						"align": 'center',
					},
					{
						"title": "未分发数量",
						"key": "not_distribute_num",
						"align": 'center',
					},
					{
						"title": "撞库数量",
						"key": "zhuangku_num",
						"align": 'center',
					},
					{
						"title": "撞库率",
						"slot": "zhuangku_rate",
						"align": 'center',
					},
					{
						"title": "0星",
						"key": "zero",
						"align": 'center',
					},
					{
						"title": "1星",
						"key": "one",
						"align": 'center',
					},
					{
						"title": "2星+以上",
						"slot": "twoplus",
						"align": 'center',
					},
					{
						"title": "3星+以上",
						"slot": "threePlus",
						"align": 'center',
					},
					{
						"title": "4星",
						"slot": "four",
						"align": 'center',
					},					
					{
						"title": "实际3星+以上",
						"slot": "threePlusReal",
						"align": 'center',
					},
				],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function() {
			this.loadData();

		},
		methods: {

			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAdvCity(that, data);
				that.cityList = res.data.list;
				res = await getCidTypeList(that, data);
				that.cidTypeList = res.data.list;
				res = await getWechatSrc(that, data);
				that.srcList = res.data.list;
				res = await getAllOperationList(that, data);
				that.operationList = res.data.list;
				this.getList();
			},
			mySearch(e) {
				this.page = 1;
				this.getList();
			},
			initSearch() {
				this.page = 1;
				this.pageSize = 20;
				this.city = '';
				this.src = '';
				this.searchAdid = '';
				this.newSearchAdid='';
				this.adgroup_id = ''
				this.timePeriod = '1';
				this.timePeriodDate = [];
				this.operationUser = [];
				this.account = [];
				this.getList();
			},
			async getList() {
				let that = this;
				let data = {}
				data.page = that.page
				data.pageSize = that.pageSize
				data.token = that.token;
				data.city = that.city
				data.src = that.src
				data.searchAdid = that.searchAdid
				data.newSearchAdid = that.newSearchAdid
				data.adgroup_id = that.adgroup_id
				data.timePeriod = that.timePeriod
				data.operationUser = that.operationUser
				data.timePeriodDate = that.timePeriodDate
				let res = await getWechatAdvDataList(that, data);
				that.datas = res.data.list;
				that.count = res.count;

			},newTidDataClick(adid){
				let that = this;
				if(adid =="合计"){
					that.adid = "";
				}else{
					that.adid = adid;
				}
				that.click_type = 'dynamic_creative_id'
				that.adidDataModal = true;				
			},
			tidDataClick(adid){
				let that = this;
				if(adid =="合计"){
					that.adid = "";
				}else{
					that.adid = adid;
				}
				that.click_type = 'tid'
				that.adidDataModal = true;				
			},
			adidDataClick(adid) {
				let that = this;
				if(adid =="合计"){
					that.adid = "";
				}else{
					that.adid = adid;
				}
				that.click_type = 'adgroup_id'
				that.adidDataModal = true;
			},
			changeDate(e) {
				//this.getList();
			},
			changeTimePeriod(e) {
				this.timePeriodDate = e;
				console.log(this.timePeriodDate)
				this.getList();
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
		},
	}
</script>
<style scoped lang="less">
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}
</style>
